import { CacheableState } from '@utils/cacheable-state';
import { RequestAction } from '../../domain';

export interface RequestsTypeState {
  allRequestsType: CacheableState<Array<any>>;
  createRequestType: CacheableState<Array<any>>;
  updateRequestType: CacheableState<Array<any>>;
  deleteRequestType: CacheableState<Array<any>>;
  requestActionsByCompany: CacheableState<Array<RequestAction>>;
  changeRequestActionType: CacheableState<Array<any>>;
}

export function requestsTypeInitialState(): RequestsTypeState {
  return {
    allRequestsType: initialDataSubState().allRequestsType,
    createRequestType: initialDataSubState().createRequestType,
    updateRequestType: initialDataSubState().updateRequestType,
    deleteRequestType: initialDataSubState().deleteRequestType,
    requestActionsByCompany: initialDataSubState().requestActionsByCompany,
    changeRequestActionType: initialDataSubState().changeRequestActionType,
  };
}
export function initialDataSubState(): RequestsTypeState {
  return {
    allRequestsType: new CacheableState(),
    createRequestType: new CacheableState(),
    updateRequestType: new CacheableState(),
    deleteRequestType: new CacheableState(),
    requestActionsByCompany: new CacheableState(),
    changeRequestActionType: new CacheableState(),
  };
}
